import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import ModalEditAnggota from '../components/ModalEditAnggota';
import { FaEdit, FaTrash, FaHistory } from 'react-icons/fa';
import Swal from 'sweetalert2';

const HistoryAnggota = () => {
  const [dataAnggota, setDataAnggota] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAnggota, setSelectedAnggota] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch hanya anggota dengan status 'nonaktif'
  const fetchDataAnggota = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota?status=nonaktif`);
      if (!response.ok) {
        throw new Error('Gagal mengambil data history anggota');
      }
      const data = await response.json();
      setDataAnggota(data);
    } catch (err) {
      Swal.fire('Error', err.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateAnggota = async (id, updatedData) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Gagal mengupdate anggota');
      }

      fetchDataAnggota();
      return 'Anggota berhasil diperbarui!';
    } catch (err) {
      throw err;
    }
  };

  const handleDeleteAnggota = async (id) => {
    const result = await Swal.fire({
      title: 'Apakah Anda yakin?',
      text: 'Data anggota yang dihapus tidak dapat dikembalikan!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, hapus!',
      cancelButtonText: 'Batal'
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota/${id}`, {
          method: 'DELETE',
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Gagal menghapus anggota');
        }

        fetchDataAnggota();
        Swal.fire('Terhapus!', 'Anggota berhasil dihapus.', 'success');
      } catch (err) {
        Swal.fire('Gagal!', err.message, 'error');
      }
    }
  };

  const handleOpenEditModal = (anggota) => {
    setSelectedAnggota(anggota);
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedAnggota(null);
  };

  useEffect(() => {
    fetchDataAnggota();
  }, []);

  return (
    <Layout title="History Anggota">
      <div className="card">
        <header className="card-header">
          <p className="card-header-title">
            <FaHistory style={{ marginRight: '10px' }} />
            History Anggota (Nonaktif)
          </p>
        </header>
        <div className="card-content">
          {loading && <p>Loading...</p>}
          {!loading && dataAnggota.length === 0 && (
            <div className="notification is-info is-light">
              Tidak ada anggota nonaktif
            </div>
          )}
          {!loading && dataAnggota.length > 0 && (
            <div className="table-container">
              <table className="table is-fullwidth is-striped">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Kode Anggota</th>
                    <th>NIS</th>
                    <th>Nama Lengkap</th>
                    <th>Kelas/Jabatan</th>
                    <th>Tahun Masuk</th>
                    <th>Tahun Lulus</th>
                    <th>Status</th>
                    <th>Keterangan</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {dataAnggota.map((anggota, index) => (
                    <tr key={anggota.id}>
                      <td>{index + 1}</td>
                      <td>{anggota.kode_anggota}</td>
                      <td>{anggota.nis}</td>
                      <td>{anggota.nama_lengkap}</td>
                      <td>{anggota.kelas}</td>
                      <td>{anggota.tahun_masuk || '-'}</td>
                      <td>{anggota.tahun_lulus || '-'}</td>
                      <td>
                        <span className="tag is-danger">Nonaktif</span>
                      </td>
                      <td>{anggota.keterangan_status || '-'}</td>
                      <td>
                        <button 
                          className="button is-info is-small" 
                          onClick={() => handleOpenEditModal(anggota)}
                          title="Edit (bisa reaktivasi)"
                        >
                          <span className="icon"><FaEdit /></span>
                        </button>
                        <button 
                          className="button is-danger is-small ml-2" 
                          onClick={() => handleDeleteAnggota(anggota.id)}
                          title="Hapus permanen"
                        >
                          <span className="icon"><FaTrash /></span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      
      {selectedAnggota && (
        <ModalEditAnggota
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          onUpdate={handleUpdateAnggota}
          anggotaData={selectedAnggota}
        />
      )}
    </Layout>
  );
};

export default HistoryAnggota;